class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 500));
    this.querySelector("form").addEventListener(
      "input",
      this.debouncedOnSubmit.bind(this)
    );
    const e = this.querySelector("#FacetsWrapperDesktop");
    e && e.addEventListener("keyup", onKeyUpEscape),
      (FacetFiltersForm.url = window.location.href),
      (FacetFiltersForm.searchParamsArr = []),
      (FacetFiltersForm.optionValues = []),
      (FacetFiltersForm.dynamicTitle =
        document.getElementsByClassName("dynamic-title")),
      (FacetFiltersForm.dynamicTitleText = FacetFiltersForm.dynamicTitle[0]
        ? FacetFiltersForm.dynamicTitle[0].textContent
            .replace(/\s/g, "")
            .slice(1)
        : ""),
      (FacetFiltersForm.optionValues =
        FacetFiltersForm.dynamicTitleText.split("-")),
      (FacetFiltersForm.ajaxFilterValues = []),
      FacetFiltersForm.renderTitle();
  }
  static setListeners() {
    window.addEventListener("popstate", (e) => {
      const t = e.state
        ? e.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev &&
        FacetFiltersForm.renderPage(t, null, !1);
    });
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll(".js-facet-remove").forEach((t) => {
      t.classList.toggle("disabled", e);
    });
  }
  static renderPage(e, t, r = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    const i = FacetFiltersForm.getSections(),
      n = document.getElementById("ProductCount"),
      s = document.getElementById("ProductCountDesktop");
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading"),
      n && n.classList.add("loading"),
      s && s.classList.add("loading"),
      i.forEach((r) => {
        const i = `${window.location.pathname}?section_id=${r.section}&${e}`,
          n = (e) => e.url === i;
        FacetFiltersForm.filterData.some(n)
          ? FacetFiltersForm.renderSectionFromCache(n, t)
          : FacetFiltersForm.renderSectionFromFetch(
              FacetFiltersForm.interceptFiltering(t, i),
              t
            );
      }),
      r && FacetFiltersForm.updateURLHash(e);
  }
  static renderSectionFromFetch(e, t) {
    fetch(e)
      .then((e) => e.text())
      .then((r) => {
        const i = r;
        (FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html: i, url: e },
        ]),
          FacetFiltersForm.renderFilters(i, t),
          FacetFiltersForm.renderProductGridContainer(i),
          FacetFiltersForm.renderProductCount(i),
          FacetFiltersForm.renderTitle(),
          "function" == typeof initializeScrollAnimationTrigger &&
            initializeScrollAnimationTrigger(i.innerHTML);
      });
  }
  static renderSectionFromCache(e, t) {
    const r = FacetFiltersForm.filterData.find(e).html;
    FacetFiltersForm.renderFilters(r, t),
      FacetFiltersForm.renderProductGridContainer(r),
      FacetFiltersForm.renderProductCount(r),
      "function" == typeof initializeScrollAnimationTrigger &&
        initializeScrollAnimationTrigger(r.innerHTML);
  }
  static renderProductGridContainer(e) {
    const t = document.getElementById("ProductGridContainer");
    if (!t) return;
    const r = new DOMParser().parseFromString(e, "text/html");
    t.innerHTML = r.getElementById("ProductGridContainer").innerHTML;
  }
  static renderProductCount(e) {
    const t = new DOMParser()
        .parseFromString(e, "text/html")
        ?.getElementById("ProductCount")?.innerHTML,
      r = document.getElementById("ProductCount"),
      i = document.getElementById("ProductCountDesktop");
    t && ((r.innerHTML = t), r.classList.remove("loading")),
      i && t && ((i.innerHTML = t), i.classList.remove("loading"));
  }
  static renderFilters(e, t) {
    const r = new DOMParser().parseFromString(e, "text/html"),
      i = r.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
      ),
      n = (e) => {
        const r = t ? t.target.closest(".js-filter") : void 0;
        return !!r && e.dataset.index === r.dataset.index;
      },
      s = Array.from(i).filter((e) => !n(e)),
      o = Array.from(i).find(n);
    s.forEach((e) => {
      document.querySelector(
        `.js-filter[data-index="${e.dataset.index}"]`
      ).innerHTML = e.innerHTML;
    }),
      FacetFiltersForm.renderActiveFacets(r),
      FacetFiltersForm.renderAdditionalElements(r),
      o && FacetFiltersForm.renderCounts(o, t.target.closest(".js-filter"));
  }
  static renderActiveFacets(e) {
    [".active-facets-mobile", ".active-facets-desktop"].forEach((t) => {
      const r = e.querySelector(t);
      r && (document.querySelector(t).innerHTML = r.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderAdditionalElements(e) {
    [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(
      (t) => {
        e.querySelector(t) &&
          (document.querySelector(t).innerHTML = e.querySelector(t).innerHTML);
      }
    ),
      document
        .getElementById("FacetFiltersFormMobile")
        .closest("menu-drawer")
        .bindEvents();
  }
  static renderCounts(e, t) {
    const r = t.querySelector(".facets__selected"),
      i = e.querySelector(".facets__selected"),
      n = t.querySelector(".facets__summary"),
      s = e.querySelector(".facets__summary");
    i &&
      r &&
      (t.querySelector(".facets__selected").outerHTML =
        e.querySelector(".facets__selected").outerHTML),
      n &&
        s &&
        (t.querySelector(".facets__summary").outerHTML =
          e.querySelector(".facets__summary").outerHTML);
  }
  static updateURLHash(e) {
    history.pushState(
      { searchParams: e },
      "",
      `${window.location.pathname}${e && "?".concat(e)}`
    );
  }
  static getSections() {
    return [{ section: document.getElementById("product-grid").dataset.id }];
  }
  createSearchParams(e) {
    const t = new FormData(e);
    let r = new URLSearchParams(t).toString(),
      i = "";
    return (
      r.split("&").filter((e) => {
        "" !== e.split("=")[1] && (i += `${e}&`);
      }),
      i.substring(0, i.length - 1)
    );
  }
  onSubmitForm(e, t) {
    FacetFiltersForm.renderPage(e, t);
  }
  removeLastElementWithValueContainingString(e, t) {
    for (let r = e.length - 1; r >= 0; r--)
      e[r].includes(t) && 0 != r && e.splice(r, 1);
  }
  onSubmitHandler(e) {
    e.preventDefault(), (FacetFiltersForm.counter = 0);
    const t = document.querySelectorAll("facet-filters-form form");
    if ("mobile-facets__checkbox" == e.srcElement.className) {
      const t = this.createSearchParams(e.target.closest("form"));
      this.onSubmitForm(t, e);
    } else {
      const r = [],
        i = "FacetFiltersFormMobile" === e.target.closest("form").id;
      t.forEach((e) => {
        if (i)
          "FacetFiltersFormMobile" === e.id &&
            r.push(this.createSearchParams(e));
        else if (
          "FacetSortForm" === e.id ||
          "FacetFiltersForm" === e.id ||
          "FacetSortDrawerForm" === e.id
        ) {
          document.querySelectorAll(".no-js-list").forEach((e) => e.remove()),
            r.push(this.createSearchParams(e)),
            FacetFiltersForm.counter++;
        }
      }),
        this.removeLastElementWithValueContainingString(r, "sort_by"),
        this.onSubmitForm(r.join("&"), e);
    }
  }
  onActiveFilterClick(e) {
    e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
    const t =
      -1 == e.currentTarget.href.indexOf("?")
        ? ""
        : e.currentTarget.href
            .replaceAll("filter.v.option.", "")
            .replaceAll("filter.v.m.global.", "")
            .replaceAll("filter.v.price.", "")
            .replaceAll("filter.p.m.custom.", "")
            .slice(e.currentTarget.href.indexOf("?") + 1);
    FacetFiltersForm.renderTitle(), FacetFiltersForm.renderPage(t);
  }
  static removeStringFromEnd(e, t) {
    if (e.endsWith(t)) {
      const r = t.length;
      return e.slice(0, -r);
    }
    return e;
  }
  static interceptFiltering(e, t) {
    let r = window.paramArr ? window.paramArr : [],
      i = t || window.location.search.substring(1),
      n = i
        .split("&")
        .map((e, t) => {
          let r = e.split("=")[0];
          if ("sort_by" !== r) return r;
        })
        .filter(function (e) {
          return null != e && "" != e && "undefined" != e;
        });
    r.filter((e) => "" !== e).filter((e, t) => {
      n.forEach((t, r) => {
        e.toLowerCase().includes(t.toLowerCase()) &&
          FacetFiltersForm.ajaxFilterValues.push({ option: e, currOption: t });
      });
    });
    return (
      Array.from(
        FacetFiltersForm.ajaxFilterValues
          .reduce((e, t) => e.set(t.currOption, t), new Map())
          .values()
      ).map((e, t) => {
        "" !== e.currOption && (i = i.replaceAll(e.currOption, e.option));
      }),
      FacetFiltersForm.getSections().map(
        (e) => `${window.location.pathname}?section_id=${e.section}&${i}`
      )
    );
  }
  static hasUndefinedValue(e) {
    for (let t in e) if (void 0 === e[t]) return !0;
    return !1;
  }
  static renderTitle() {
    let e = document.getElementsByClassName("dynamic-title")[0];
    setTimeout(() => {
      let t = [],
        r = new URLSearchParams(window.location.search);
      if (r.has("utm_source")) return;
      r.delete("sort_by"), r.delete("view"), r.delete("slScreenshot");
      for (let [e, i] of r.entries()) t.push({ [e]: i });
      const i = {};
      for (const [e, r] of Object.entries(t))
        for (const [t, n] of Object.entries(r)) {
          i[t] || (i[t] = {});
          for (const r of [n].flat()) i[t][e] = r;
        }
      const n = Object.entries(i).map(([e, t]) => ({ key: e, value: t }));
      let s = 0,
        o = ["utm source", "utm medium", "utm campaign", "sort by", "phcursor"],
        a = n
          .map((e, t) => {
            let r = e.key.replace(/_/g, " ");
            if (!o.includes(r)) {
              let i = "";
              0 != t || this.hasUndefinedValue(e.value) || (i += " - "),
                this.hasUndefinedValue(e.value) || (i += r + ": ");
              for (const t in e.value)
                s >= Object.keys(e.value).length - 1 && 0 >= n.length - 1
                  ? e.value[t] && (i += e.value[t])
                  : e.value[t] && (i += e.value[t] + ", "),
                  s++;
              return i;
            }
          })
          .join("");
      (a = a.replace(/,\s*$/, "")),
        e &&
          (e.innerHTML =
            window.collectionName.replace(/-\s*$/, "") +
            a
              .replaceAll("+%2F+", " / ")
              .replaceAll("%2F", " / ")
              .replaceAll("+%2B+", " + "));
    }, 200);
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define("facet-filters-form", FacetFiltersForm),
  FacetFiltersForm.setListeners();
const url = window.location.href,
  substrings = [
    "color",
    "bong_joint_type",
    "joint_size",
    "filter.v.price.gte",
    "filter.v.price.lte",
    "seed_type",
  ];
for (let e = 0; e < substrings.length; e++)
  url.includes(substrings[e]) &&
    FacetFiltersForm.renderSectionFromFetch(
      FacetFiltersForm.interceptFiltering((formUrl = url))
    );
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll("input").forEach((e) =>
        e.addEventListener("change", this.onRangeChange.bind(this))
      ),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const e = this.querySelectorAll("input"),
      t = e[0],
      r = e[1];
    r.value && t.setAttribute("max", r.value),
      t.value && r.setAttribute("min", t.value),
      "" === t.value && r.setAttribute("min", 0),
      "" === r.value && t.setAttribute("max", r.getAttribute("max"));
  }
  adjustToValidValues(e) {
    const t = Number(e.value),
      r = Number(e.getAttribute("min")),
      i = Number(e.getAttribute("max"));
    t < r && (e.value = r), t > i && (e.value = i);
  }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector("a");
    e.setAttribute("role", "button"),
      e.addEventListener("click", this.closeFilter.bind(this)),
      e.addEventListener("keyup", (e) => {
        e.preventDefault(),
          "SPACE" === e.code.toUpperCase() && this.closeFilter(e);
      });
  }
  closeFilter(e) {
    e.preventDefault();
    (
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form")
    ).onActiveFilterClick(e);
  }
}
customElements.define("facet-remove", FacetRemove);